import classNames from 'classnames'
import * as React from 'react'
import {render} from 'storyblok-rich-text-react-renderer'

import {makeEditable} from '@/common/utils'
import Buttons from '@/components/Buttons'
import {Grid} from '@/components/Grid'
import Heading from '@/components/Heading'
import Image from '@/components/Image'

const CtaCard = ({
  headingTag,
  heading,
  tag,
  content,
  buttons,
  image,
  backgroundSection,
  backgroundCard,
  _editable,
}) => {
  const HeadingTag = headingTag || 'p'

  return (
    <section
      {...makeEditable(_editable)}
      className={classNames('py-14', {
        'bg-white': backgroundSection === 'light',
        'bg-purple-900': backgroundSection === 'dark',
      })}
    >
      <Grid>
        <div
          className={classNames(
            'col-span-full flex flex-col gap-8 rounded-3xl px-4 py-10 md:p-11 lg:col-start-2 lg:col-end-12 lg:flex-row lg:gap-8 lg:px-21',
            {
              'bg-white': backgroundCard === 'white',
              'bg-purple-900 text-white': backgroundCard === 'purple',
              'bg-yellow-200': backgroundCard === 'yellow',
              'bg-purple-200': backgroundCard === 'purple-light',
            }
          )}
        >
          <div
            className={classNames('flex flex-col justify-center gap-4', {
              'mx-auto max-w-[510px]': !image.filename,
            })}
          >
            <div
              className={classNames('flex justify-center', {
                'lg:justify-center': !image.filename,
                'lg:justify-start': image.filename,
              })}
            >
              <h2 className='bg-tag misc-button-s flex justify-center rounded-full px-4 py-1 uppercase text-white '>
                {tag}
              </h2>
            </div>
            <HeadingTag>
              <Heading
                heading={heading}
                className={classNames('heading-xs-millik text-center text-purple-900  ', {
                  '[&>span]:text-white': backgroundCard === 'purple',
                  '[&>span]:text-purple-900': backgroundCard !== 'purple',
                  'lg:text-left': image.filename,
                  'lg:text-center': !image.filename,
                })}
              />
            </HeadingTag>

            <p
              className={classNames('body-s-medium text-center lg:text-left', {
                'lg:text-center': !image.filename,
                'lg:text-left': image.filename,
              })}
            >
              {render(content)}
            </p>
            <div className='flex flex-col gap-4'>
              <Buttons
                buttons={buttons}
                className={classNames('flex items-center justify-center gap-4 lg:justify-start', {
                  '[&>*>span]:border-white [&>*>span]:text-white': backgroundCard === 'purple',
                  'lg:justify-start': image.filename,
                  'lg:justify-center': !image.filename,
                })}
              />
            </div>
          </div>
          {image && image.filename && (
            <Image
              {...image}
              className='rounded-2xl md:mx-auto md:max-w-[300px]'
              sizes={{md: 50, lg: 33}}
              ratio={'1:1'}
            />
          )}
        </div>
      </Grid>
    </section>
  )
}

export default CtaCard
